import React from "react";
import {BasePaymentSummaryPage} from "./BasePaymentSummaryPage";
import {BackofficeSummaryFilter} from "./BackofficeSummaryFilter";

export const BackofficePaymentSummaryPage = () => {
    return (
        <BasePaymentSummaryPage
            filtersComponent={BackofficeSummaryFilter}
            isBackoffice={true}
        />
    );
}; 